import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const SIGNUP = gql`
  mutation SignupUser($input: SignupInput!) {
    signupUser(input: $input) {
      user {
        ...identificationFields
      }
      token
    }
  }
  ${fragments.IDENTIFICATION_FRAGMENT}
`;

export const LOGIN = gql`
  mutation LoginUser($input: LoginInput!) {
    loginUser(input: $input) {
      user {
        ...identificationFields
      }
      token
    }
  }
  ${fragments.IDENTIFICATION_FRAGMENT}
`;

export const UPDATE_AUTH_STATUS = gql`
  mutation UpdateAuthStatus($isAuthenticated: Boolean!, $currentUser: User!) {
    updateAuthStatus(
      isAuthenticated: $isAuthenticated
      currentUser: $currentUser
    ) @client
  }
`;

export const AUTH_FACEBOOK = gql`
  mutation AuthFacebook($input: AuthInput!) {
    authFacebook(input: $input) {
      token
      name
    }
  }
`;

export const AUTH_GOOGLE = gql`
  mutation AuthGoogle($input: AuthInput!) {
    authGoogle(input: $input) {
      token
      name
    }
  }
`;
